module.exports = __webpack_public_path__ + "static/media/W19-1193_Free_Root_Beer_Day_Mobile_767x845_FR.4477c6ce.jpg";